import { createFileRoute } from '@tanstack/react-router';

import { GdprContainer } from '@/features/settings/containers/gdpr';

export const Route = createFileRoute('/_layout/settings/_layout/gdpr/')({
  component: GdprContainer,
});
